import { ReactElement, ReactNode } from "react";

import { Row } from "@/components/Row";
import { SheetSectionContainer } from "@/components/SheetSectionContainer";
import { SheetSectionHeader } from "@/components/SheetSectionHeader";

export const SkillsWrapper = ({
  children,
  editControls,
  isEmpty,
}: {
  children: ReactElement;
  editControls?: ReactNode;
  isEmpty?: boolean;
}) => (
  <SheetSectionContainer>
    <Row className="items-center justify-between">
      <SheetSectionHeader isEmpty={isEmpty} title="Skills" />
      {editControls}
    </Row>
    {children}
  </SheetSectionContainer>
);
